import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Calculator from "@/pages/Calculator";
import GanttPage from "@/pages/GanttPage";
import SettingsPage from "@/pages/SettingsPage";
import { SettingsProvider } from "@/hooks/useSettings";
import { ErrorBoundary } from "@/components/jackstone/ErrorBoundary";
// Saved Scenarios UI hidden per request (page + route kept for later).
// import ScenariosPage from "@/pages/ScenariosPage";

function App() {
  return (
    <ErrorBoundary>
      <SettingsProvider>
      <BrowserRouter>
        <div className="App">
          {/* One toast host for every page (sonner) */}
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Calculator />} />
            <Route path="/gantt" element={<GanttPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            {/* <Route path="/scenarios" element={<ScenariosPage />} /> */}
          </Routes>
        </div>
      </BrowserRouter>
      </SettingsProvider>
    </ErrorBoundary>
  );
}

export default App;
